import React, { useEffect, useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import Hero from '../components/sections/Hero';
import About from '../components/sections/About';
import Values from '../components/sections/Values';
import Services from '../components/sections/Services';
import Methodology from '../components/sections/Methodology';
import Sectors from '../components/sections/Sectors';
import Products from '../components/sections/Products';
import LatestArticles from '../components/sections/LatestArticles';
import Contact from '../components/sections/Contact';
import SEO from '../components/SEO';
import { organizationSchema, websiteSchema } from '../lib/seoConstants';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

const sectionMap = {
  hero: Hero,
  about: About,
  values: Values,
  services: Services,
  methodology: Methodology,
  sectors: Sectors,
  products: Products,
  articles: LatestArticles,
  contact: Contact,
};

const defaultOrder = ['hero', 'about', 'values', 'services', 'methodology', 'sectors', 'products', 'articles', 'contact'];

const LandingPage = () => {
  const { isRTL } = useLanguage();
  const [enabledSections, setEnabledSections] = useState(null);

  useEffect(() => {
    axios.get(`${API}/api/sections`).then(res => {
      const map = {};
      res.data.forEach(s => { map[s.id] = s.enabled; });
      setEnabledSections(map);
    }).catch(() => {});
  }, []);

  const dir = isRTL ? 'rtl' : 'ltr';
  const fontFamily = isRTL ? "'Cairo', 'Tajawal', sans-serif" : "'DM Sans', 'Inter', sans-serif";

  return (
    <div dir={dir} style={{ fontFamily }}>
      <SEO
        path="/"
        schemas={[organizationSchema(), websiteSchema()]}
      />
      <Header />
      {defaultOrder.map(id => {
        if (enabledSections && enabledSections[id] === false) return null;
        const Section = sectionMap[id];
        return Section ? <Section key={id} /> : null;
      })}
      <Footer />
    </div>
  );
};

export default LandingPage;
